import { createFileRoute } from '@tanstack/react-router';

/**
 * Results Dashboard Index Route Definition
 * Component is loaded from index.lazy.tsx for automatic code splitting
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/results/dashboard/')({
  // No beforeLoad - parent _protected handles auth
});
